'use strict';

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMPOSING = exports.COMPOSING = typeof Symbol === 'function' ? Symbol('composing') : '@@react-decorate/composing';